import React, {useEffect, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import connection from "../../connection";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import Accordion from "../../components/Accordion/Accordion";
import ReactMarkdown from "react-markdown";
import Room from "@material-ui/icons/Room";
import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";
import faqStyle from "assets/jss/material-dashboard-pro-react/views/faqStyle.jsx";

function garantirSecao(seccoes) {
  if (seccoes.length === 0) {
    seccoes.push({
      titulo: "FAQ",
      gerada: true,
      introducao: [],
      questoes: []
    });
  }
  return seccoes[seccoes.length - 1];
}

function parseFAQMarkdown(markdown) {
  const seccoes = [];
  let seccaoAtual = null;
  let questaoAtual = null;

  markdown.replace(/\r\n/g, "\n").split("\n").forEach((linha) => {
    let matchSeccao = linha.match(/^#\s+(.*)$/);
    if (matchSeccao) {
      seccaoAtual = {
        titulo: matchSeccao[1].trim(),
        gerada: false,
        introducao: [],
        questoes: []
      };
      seccoes.push(seccaoAtual);
      questaoAtual = null;
      return;
    }

    let matchQuestao = linha.match(/^##\s+(.*)$/);
    if (matchQuestao) {
      seccaoAtual = garantirSecao(seccoes);
      questaoAtual = {
        titulo: matchQuestao[1].trim(),
        resposta: []
      };
      seccaoAtual.questoes.push(questaoAtual);
      return;
    }

    seccaoAtual = garantirSecao(seccoes);
    if (questaoAtual) {
      questaoAtual.resposta.push(linha);
    } else {
      seccaoAtual.introducao.push(linha);
    }
  });

  return seccoes
    .map((seccao) => ({
      ...seccao,
      introducao: seccao.introducao.join("\n").trim(),
      questoes: seccao.questoes.map((questao) => ({
        ...questao,
        resposta: questao.resposta.join("\n").trim()
      }))
    }))
    .filter((seccao) => seccao.introducao || seccao.questoes.length > 0 || !seccao.gerada);
}

function FAQ(props) {
  const {classes} = props;
  const [markdown, setMarkdown] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    connection.get("faq").then((dados) => {
      setMarkdown(dados.markdown || "");
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const seccoes = parseFAQMarkdown(markdown);
  const markdownIntroducaoComponents = {
    p: (markdownProps) => <p className={classes.markdownParagraph} {...markdownProps} />,
    strong: (markdownProps) => <strong className={classes.markdownStrong} {...markdownProps} />
  };
  const markdownRespostaComponents = {
    p: (markdownProps) => <p className={classes.markdownParagraph} {...markdownProps} />,
    strong: (markdownProps) => <strong className={classes.markdownStrong} {...markdownProps} />,
    h1: (markdownProps) => <h1 className={classes.markdownH1} {...markdownProps} />,
    h2: (markdownProps) => <h2 className={classes.markdownH2} {...markdownProps} />,
    h3: (markdownProps) => <h3 className={classes.markdownH3} {...markdownProps} />,
    h4: (markdownProps) => <h4 className={classes.markdownH4} {...markdownProps} />,
    ul: (markdownProps) => <ul className={classes.markdownList} {...markdownProps} />,
    ol: (markdownProps) => <ol className={classes.markdownList} {...markdownProps} />,
    li: (markdownProps) => <li className={classes.markdownListItem} {...markdownProps} />
  };

  const contactoCard = <div className={classes.contactSection}>
    <h3 className={classes.contactSectionTitle}>Precisa de ajuda adicional?</h3>
    <Card className={classes.contactCard}>
      <CardBody className={classes.contactCardBody}>
        <div className={classes.contactIntro}>
          <p className={classes.contactLine}>Corpo Nacional de Escutas</p>
          <p className={classes.contactSubline}>Plataforma Nacional de Gestão da Formação</p>
        </div>
        <div className={classes.contactItems}>
          <div className={classes.contactItem}>
            <div className={classes.contactIconWrap}>
              <Room className={classes.contactIcon}/>
            </div>
            <div className={classes.contactItemBody}>
              <p className={classes.contactItemLabel}>Morada</p>
              <p className={classes.contactDetail}>Rua D. Luís I nº34, 1200-152 Lisboa</p>
            </div>
          </div>
          <div className={classes.contactItem}>
            <div className={classes.contactIconWrap}>
              <Phone className={classes.contactIcon}/>
            </div>
            <div className={classes.contactItemBody}>
              <p className={classes.contactItemLabel}>Telefone</p>
              <p className={classes.contactDetail}>218 427 020</p>
            </div>
          </div>
          <div className={classes.contactItem}>
            <div className={classes.contactIconWrap}>
              <Email className={classes.contactIcon}/>
            </div>
            <div className={classes.contactItemBody}>
              <p className={classes.contactItemLabel}>E-mail</p>
              <p className={classes.contactDetail}><a href="mailto:cordilheira.ajuda@escutismo.pt">cordilheira.ajuda@escutismo.pt</a></p>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  </div>;

  return <GridContainer>
    <GridItem xs={12}>
      <div className={classes.page}>
        {loading && <Card><CardBody><p style={{marginBottom: 0}}>A carregar...</p></CardBody></Card>}
        {!loading && !!markdown.trim() && seccoes.map((seccao, idxSeccao) => <div key={"faq-seccao-" + idxSeccao} className={classes.section}>
          <h3 className={classes.sectionTitle}>{seccao.titulo}</h3>
          {seccao.introducao && <div className={classes.sectionIntro}>
            <ReactMarkdown components={markdownIntroducaoComponents}>{seccao.introducao}</ReactMarkdown>
          </div>}
          {seccao.questoes.length > 0 && seccao.questoes.map((questao, idxQuestao) => <Card className={classes.questionCard} key={"faq-questao-" + idxSeccao + "-" + idxQuestao}>
            <CardBody className={classes.questionCardBody}>
              <Accordion
                singleActive
                expansionPanelProps={{
                  className: classes.accordionPanel
                }}
                expansionPanelSummaryProps={{
                  className: classes.accordionSummary
                }}
                collapses={[{
                  title: questao.titulo,
                  content: <div className={classes.answerContent}>
                    <ReactMarkdown components={markdownRespostaComponents}>{questao.resposta}</ReactMarkdown>
                  </div>
                }]}
              />
            </CardBody>
          </Card>)}
        </div>)}
        {!loading && contactoCard}
      </div>
    </GridItem>
  </GridContainer>;
}

export default withStyles(faqStyle)(FAQ);
